"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Box = _interopRequireDefault(require("../Box/Box"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Dropdown = _interopRequireDefault(require("./Dropdown"));

var _SelectedList = _interopRequireDefault(require("./SelectedList"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
var activeDropdown = (0, _styledComponents.css)(["background-color:", ";border-bottom:2px solid ", ";&:hover{background-color:", ";border-bottom:2px solid ", ";}&:focus{background-color:", ";border-bottom:2px solid ", ";}& > div > i{transform:rotate(180deg);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[5];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary[0];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dark[5];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary[0];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[5];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary[0];
});
var SearchBar = (0, _styledComponents["default"])(_TextField["default"]).withConfig({
  displayName: "CategorySelectSearch__SearchBar",
  componentId: "sc-sx5kh6-0"
})(["border-bottom:1px solid ", ";background-color:", ";border-radius:4px 4px 0 0;&:focus{background-color:", ";border-bottom:2px solid ", ";transition:0.15s;}&:hover{background-color:", ";border-bottom:1px solid ", ";}", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[3];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.dark[7];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.dark[5];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary[0];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.dark[6];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.dark[1];
}, function (_ref13) {
  var isActive = _ref13.isActive;
  return isActive && activeDropdown;
});

var CategorySelectSearch = function CategorySelectSearch(_ref14) {
  var dropdownRowHeight = _ref14.dropdownRowHeight,
      dropdownContainerHeight = _ref14.dropdownContainerHeight,
      dropdownBuffer = _ref14.dropdownBuffer,
      columsPerDeviceType = _ref14.columsPerDeviceType,
      name = _ref14.name,
      label = _ref14.label,
      onChange = _ref14.onChange,
      closeDropdownTrigger = _ref14.closeDropdownTrigger,
      _ref14$width = _ref14.width,
      width = _ref14$width === void 0 ? 1 / 1 : _ref14$width,
      values = _ref14.values,
      title = _ref14.title,
      _ref14$checkboxColour = _ref14.checkboxColour,
      checkboxColour = _ref14$checkboxColour === void 0 ? "primary.0" : _ref14$checkboxColour,
      _ref14$active = _ref14.active,
      active = _ref14$active === void 0 ? "primary" : _ref14$active,
      _ref14$inactive = _ref14.inactive,
      inactive = _ref14$inactive === void 0 ? "dark" : _ref14$inactive,
      _ref14$maxSelect = _ref14.maxSelect,
      maxSelect = _ref14$maxSelect === void 0 ? Infinity : _ref14$maxSelect,
      showSelectAll = _ref14.showSelectAll,
      _ref14$selectAllButto = _ref14.selectAllButtonStyles,
      selectAllButtonStyles = _ref14$selectAllButto === void 0 ? {} : _ref14$selectAllButto,
      _ref14$wrapSelection = _ref14.wrapSelection,
      wrapSelection = _ref14$wrapSelection === void 0 ? false : _ref14$wrapSelection,
      _ref14$selectedValues = _ref14.selectedValues,
      selectedValues = _ref14$selectedValues === void 0 ? [] : _ref14$selectedValues;

  var _useState = (0, _react.useState)(false),
      isDropdownVisible = _useState[0],
      setisDropdownVisible = _useState[1];

  var _useState2 = (0, _react.useState)(selectedValues),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      hasSelectedAll = _useState3[0],
      setHasSelectedAll = _useState3[1];

  var _useState4 = (0, _react.useState)(""),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var toggleDropdown = function toggleDropdown() {
    return setisDropdownVisible(!isDropdownVisible);
  };

  var isSelected = function isSelected(id) {
    return !!selected.find(function (selectedItem) {
      return selectedItem === id;
    });
  };

  var toggleSelection = function toggleSelection(id) {
    return isSelected(id) ? setSelected(selected.filter(function (item) {
      return item !== id;
    })) : setSelected([].concat(selected, [id]));
  };

  var toggleSelectAll = function toggleSelectAll() {
    return hasSelectedAll ? setSelected([]) : setSelected(values.map(function (v) {
      return v.id;
    }));
  };

  var searchFilteredCategories = values.filter(function (value) {
    return value.name.toLowerCase().includes(searchTerm.toLowerCase());
  });
  (0, _react.useEffect)(function () {
    if (selected.length === values.length) {
      setHasSelectedAll(true);
    } else {
      setHasSelectedAll(false);
    }
  }, [selected.length, values.length]);
  /**
   * Opens/closes the dropdown's contents when either the space bar or enter key
   * have been pressed whilst the dropdown is focused.
   * @param {Event} event the key press DOM event.
   */

  (0, _react.useEffect)(function () {
    // Formik expects an object with target, name and value. It won't
    // work otherwise.
    var customEventForFormik = {
      target: {
        name: name,
        value: selected
      }
    };
    onChange(customEventForFormik);
  }, [selected, name, onChange]);
  (0, _react.useEffect)(function () {
    setisDropdownVisible(false);
  }, [closeDropdownTrigger]);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 3,
    position: "relative",
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    justifyContent: "space-between",
    width: 1,
    alignItems: "flex-end"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    fontWeight: 500,
    color: "dark.2",
    fontSize: 4
  }, title), showSelectAll && /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    onClick: toggleSelectAll,
    type: "button",
    variant: "secondary.0",
    elevation: 0,
    pr: "4px",
    pl: "4px",
    height: "18px",
    fontSize: "10px",
    width: "85px"
  }, selectAllButtonStyles), hasSelectedAll ? "Unselect All" : "Select All")), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    flexDirection: "column",
    position: "relative",
    onClick: toggleDropdown,
    isActive: isDropdownVisible,
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement(SearchBar, {
    hideLabels: true,
    onChange: function onChange(e) {
      setSearchTerm(e.target.value);
      setisDropdownVisible(true);
    },
    value: searchTerm,
    px: 3,
    width: 1 / 1,
    placeholder: label,
    trailingIcon: isDropdownVisible ? "arrow_drop_down" : "arrow_drop_up"
  })), (selected == null ? void 0 : selected.length) > 0 && /*#__PURE__*/_react["default"].createElement(_SelectedList["default"], {
    width: 1 / 1,
    values: values,
    selected: selected,
    active: active,
    inactive: inactive,
    wrapSelection: wrapSelection,
    toggleSelection: toggleSelection
  }), isDropdownVisible && /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    columsPerDeviceType: columsPerDeviceType,
    dropdownRowHeight: dropdownRowHeight,
    dropdownContainerHeight: dropdownContainerHeight,
    dropdownBuffer: dropdownBuffer,
    values: searchFilteredCategories,
    checkboxColour: checkboxColour,
    isSelected: isSelected,
    toggleSelection: toggleSelection,
    selected: selected,
    maxSelect: maxSelect
  }));
};

CategorySelectSearch.propTypes = {
  dropdownRowHeight: _propTypes["default"].number,
  dropdownContainerHeight: _propTypes["default"].number,
  dropdownBuffer: _propTypes["default"].number,
  columsPerDeviceType: _propTypes["default"].shape({
    MOBILE: _propTypes["default"].number,
    TABLET: _propTypes["default"].number,
    DESKTOP: _propTypes["default"].number
  })
};
var _default = CategorySelectSearch;
exports["default"] = _default;